import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { authApi, portalApi } from '../services/portalApi';
import { queryKeys } from './queryKeys';

const FIVE_MIN = 5 * 60 * 1000;

export function useMeQuery({ enabled = true } = {}) {
  return useQuery({ queryKey: queryKeys.me, queryFn: portalApi.me, staleTime: FIVE_MIN, enabled });
}

export function useLocationsQuery() {
  return useQuery({
    queryKey: queryKeys.locations,
    queryFn: portalApi.locations,
    select: (res) => res.locations || [],
    staleTime: FIVE_MIN
  });
}

function useOrganizationPatch(mutationFn, field) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: (res) =>
      queryClient.setQueryData(queryKeys.me, (me) =>
        me ? { ...me, organization: { ...me.organization, [field]: res[field] } } : me
      )
  });
}

export function useUpdateBrandingMutation() {
  return useOrganizationPatch(portalApi.updateBranding, 'branding');
}

export function useUpdateNotificationsMutation() {
  return useOrganizationPatch(portalApi.updateNotifications, 'notifications');
}

export function useChangePasswordMutation() {
  return useMutation({
    mutationFn: ({ currentPassword, newPassword }) => authApi.changePassword(currentPassword, newPassword)
  });
}
